import i18n from "@/plugins/vue-i18n";


class DataService {
    identityCompany = [
        {
            id: 1,
            key: "identity",
            filter: "raison_sociale",
            name: i18n.tc('enrichissement.data.datas.raison_sociale')
        },
        {
            id: 2,
            key: "identity",
            filter: "nom_complet",
            name: i18n.tc('nom_complet_company')
        },
        {
            id: 3,
            key: "identity",
            filter: "status_societe",
            name: i18n.tc('status_societe')
        },
        {
            id: 4,
            key: "identity",
            filter: "enseignes",
            name: i18n.tc('enrichissement.data.datas.enseignes_societe')
        },
        {
            id: 5,
            key: "identity",
            filter: "activite_declaree",
            name: i18n.tc('activite_declaree')
        },
        {
            id: 6,
            key: "identity",
            filter: "categorie_entreprise",
            name: i18n.tc('categorie_entreprise')
        },
        {
            id: 7,
            key: "identity",
            filter: "capital_social",
            name: i18n.tc('capital_social')
        },
        {
            id: 8,
            key: "identity",
            filter: "code_naf",
            name: i18n.tc('code_naf')
        },
        {
            id: 9,
            key: "identity",
            filter: "libelle_code_naf",
            name: i18n.tc('libelle_code_naf')
        },
        {
            id: 10,
            key: "identity",
            filter: "code_forme_juridique",
            name: i18n.tc('code_forme_juridique')
        },
        {
            id: 11,
            key: "identity",
            filter: "libelle_forme_juridique",
            name: i18n.tc('libelle_forme_juridique')
        },
        {
            id: 12,
            key: "identity",
            filter: "date_immatriculation",
            name: i18n.tc('date_immatriculation')
        },
        {
            id: 13,
            key: "identity",
            filter: "rcs",
            name: i18n.tc('rcs')
        },
        {
            id: 14,
            key: "identity",
            filter: "numero_tva",
            name: i18n.tc('enrichissement.data.datas.numero_tva')
        },
        {
            id: 15,
            key: "identity",
            filter: "sigle",
            name: i18n.tc('sigle')
        },
        {
            id: 16,
            key: "identity",
            filter: "tranche_effectif_societe",
            name: i18n.tc('tranche_effectif_societe')
        },
        {
            id: 17,
            key: "identity",
            filter: "adresse",
            name: i18n.tc('adresse_company')
        },
        {
            id: 18,
            key: "identity",
            filter: "adresse_complement",
            name: i18n.tc('adresse_complement_company')
        },
        {
            id: 19,
            key: "identity",
            filter: "adresse_codepostal",
            name: i18n.tc('adresse_codepostal_company')
        },
        {
            id: 20,
            key: "identity",
            filter: "adresse_ville",
            name: i18n.tc('adresse_ville_company')
        },
        {
            id: 21,
            key: "identity",
            filter: "adresse_cedex",
            name: i18n.tc('adresse_cedex_company')
        },
        {
            id: 22,
            key: "identity",
            filter: "adresse_code_departement",
            name: i18n.tc('adresse_code_departement_company')
        },
        {
            id: 23,
            key: "identity",
            filter: "adresse_libelle_departement",
            name: i18n.tc('adresse_libelle_departement_company')
        },
        {
            id: 24,
            key: "identity",
            filter: "adresse_code_region",
            name: i18n.tc('adresse_code_region_company')
        },
        {
            id: 25,
            key: "identity",
            filter: "adresse_libelle_region",
            name: i18n.tc('adresse_libelle_region_company')
        },
        {
            id: 26,
            key: "identity",
            filter: "adresse_pays",
            name: i18n.tc('adresse_pays_company')
        },
        {
            id: 27,
            key: "identity",
            filter: "geoloc_longitude",
            name: i18n.tc('geoloc_longitude_company')
        },
        {
            id: 28,
            key: "identity",
            filter: "geoloc_latitude",
            name: i18n.tc('geoloc_latitude_company')
        },
        {
            id: 29,
            key: "identity",
            filter: "telephone_societe",
            name: i18n.tc('telephone_societe')
        },
        {
            id: 30,
            key: "identity",
            filter: "site_web",
            name: i18n.tc('site_web')
        },
        {
            id: 31,
            key: "identity",
            filter: "siret_siege",
            name: i18n.tc('siret_siege')
        }
    ];

    identityEstablishment = [
        {
            id: 1,
            key: "identity",
            filter: "siren_societe",
            name: i18n.tc('siren')
        },
        {
            id: 2,
            key: "identity",
            filter: "raison_sociale",
            name: i18n.tc('enrichissement.data.datas.raison_sociale')
        },
        {
            id: 3,
            key: "identity",
            filter: "nom_complet",
            name: i18n.tc('nom_complet_establishment')
        },
        {
            id: 4,
            key: "identity",
            filter: "statut_etablissement",
            name: i18n.tc('statut_etablissement')
        },
        {
            id: 5,
            key: "identity",
            filter: "type_etablissement",
            name: i18n.tc('type_etablissement')
        },
        {
            id: 6,
            key: "identity",
            filter: "enseigne",
            name: i18n.tc('enrichissement.data.datas.enseignes_etablishement')
        },
        {
            id: 7,
            key: "identity",
            filter: "code_naf",
            name: i18n.tc('code_naf')
        },
        {
            id: 8,
            key: "identity",
            filter: "libelle_code_naf",
            name: i18n.tc('libelle_code_naf')
        },
        {
            id: 9,
            key: "identity",
            filter: "date_creation_etablissement",
            name: i18n.tc('date_creation_etablissement')
        },
        {
            id: 10,
            key: "identity",
            filter: "sigle",
            name: i18n.tc('sigle')
        },
        {
            id: 11,
            key: "identity",
            filter: "tranche_effectif_etablissement",
            name: i18n.tc('tranche_effectif_etablissement')
        },
        {
            id: 12,
            key: "identity",
            filter: "adresse_physique",
            name: i18n.tc('adresse_physique')
        },
        {
            id: 13,
            key: "identity",
            filter: "adresse",
            name: i18n.tc('adresse_establishment')
        },
        {
            id: 14,
            key: "identity",
            filter: "adresse_physique_complement",
            name: i18n.tc('adresse_physique_complement')
        },
        {
            id: 15,
            key: "identity",
            filter: "adresse_complement",
            name: i18n.tc('adresse_complement_establishment')
        },
        {
            id: 16,
            key: "identity",
            filter: "adresse_distribution_speciale",
            name: i18n.tc('adresse_distribution_speciale')
        },
        {
            id: 17,
            key: "identity",
            filter: "adresse_physique_codepostal",
            name: i18n.tc('adresse_physique_codepostal')
        },
        {
            id: 18,
            key: "identity",
            filter: "adresse_codepostal",
            name: i18n.tc('adresse_codepostal_establishment')
        },
        {
            id: 19,
            key: "identity",
            filter: "adresse_physique_ville",
            name: i18n.tc('adresse_physique_ville')
        },
        {
            id: 20,
            key: "identity",
            filter: "adresse_ville",
            name: i18n.tc('adresse_ville_establishment')
        },
        {
            id: 21,
            key: "identity",
            filter: "adresse_cedex",
            name: i18n.tc('adresse_cedex_establishment')
        },
        {
            id: 22,
            key: "identity",
            filter: "adresse_physique_departement",
            name: i18n.tc('adresse_physique_departement')
        },
        {
            id: 23,
            key: "identity",
            filter: "adresse_code_departement",
            name: i18n.tc('adresse_code_departement_establishment')
        },
        {
            id: 24,
            key: "identity",
            filter: "adresse_libelle_departement",
            name: i18n.tc('adresse_libelle_departement_establishment')
        },
        {
            id: 25,
            key: "identity",
            filter: "adresse_code_region",
            name: i18n.tc('adresse_code_region_establishment')
        },
        {
            id: 26,
            key: "identity",
            filter: "adresse_libelle_region",
            name: i18n.tc('adresse_libelle_region_establishment')
        },
        {
            id: 27,
            key: "identity",
            filter: "adresse_pays",
            name: i18n.tc('adresse_pays_establishment')
        },
        {
            id: 28,
            key: "identity",
            filter: "geoloc_longitude",
            name: i18n.tc('geoloc_longitude_establishment')
        },
        {
            id: 29,
            key: "identity",
            filter: "geoloc_latitude",
            name: i18n.tc('geoloc_latitude_establishment')
        },
        {
            id: 30,
            key: "identity",
            filter: "siret_siege",
            name: i18n.tc('siret_siege')
        }
    ];

    dataWithoutIdentity = [{
        id: -2, name: i18n.tc('enrichissement.data.datas.solvability'), children: [
            {
                id: 31,
                key: "solvability",
                filter: 'score',
                name: i18n.tc('score')
            },
            {
                id: 32,
                key: "solvability",
                filter: 'tranche_risque',
                name: i18n.tc('risk_tranche')
            },
            {
                id: 33,
                key: "solvability",
                filter: 'etat',
                name: i18n.tc('state')
            },
            {
                id: 34,
                key: "solvability",
                filter: 'motif_cessation',
                name: i18n.tc('motif_cessation')
            },
            {
                id: 35,
                key: "solvability",
                filter: 'avis_de_credit',
                name: i18n.tc('avis_de_credit')
            },
            {
                id: 36,
                key: "solvability",
                filter: 'capacite_reboursement',
                name: i18n.tc('capacite_reboursement')
            },
            {
                id: 10,
                key: "solvability",
                filter: 'solvabilite_generale',
                name: i18n.tc('solvabilite_generale')
            },
            {
                id: 11,
                key: "solvability",
                filter: 'liquidite_generale',
                name: i18n.tc('liquidite_generale')
            },

            {
                id: 12,
                key: "solvability",
                filter: 'liquidite_reduite',
                name: i18n.tc('liquidite_reduite')
            },
            {
                id: 13,
                key: "solvability",
                filter: 'endettement',
                name: i18n.tc('endettement')
            },
            {
                id: 14,
                key: "solvability",
                filter: 'bfr',
                name: i18n.tc('bfr')
            },
            {
                id: 15,
                key: "solvability",
                filter: 'rotation_bfr',
                name: i18n.tc('rotation_bfr')
            },
            {
                id: 16,
                key: "solvability",
                filter: 'delai_reglement_client',
                name: i18n.tc('delai_reglement_client')
            },
            {
                id: 17,
                key: "solvability",
                filter: 'delai_reglement_fournisseur',
                name: i18n.tc('delai_reglement_fournisseur')
            }
        ]
    },
        {
            id: -3, name: i18n.tc('enrichissement.data.datas.finance'), children: [
                {
                    id: 18,
                    key: "finance",
                    filter: 'date_cloture',
                    name: i18n.tc('date_cloture')
                },
                {
                    id: 19,
                    key: "finance",
                    filter: 'dernier_bilan_publie',
                    name: i18n.tc('dernier_bilan_publie')
                },
                {
                    id: 20,
                    key: "finance",
                    filter: 'confidentialite_bilan',
                    name: i18n.tc('confidentialite_bilan')
                },
                {
                    id: 21,
                    key: "finance",
                    filter: 'duree_exercice',
                    name: i18n.tc('duree_exercice')
                },
                {
                    id: 22,
                    key: "finance",
                    filter: 'chiffre_affaires',
                    name: i18n.tc('chiffre_affaires')
                },
                {
                    id: 23,
                    key: "finance",
                    filter: 'resultat_exploitation',
                    name: i18n.tc('resultat_exploitation')
                },
                {
                    id: 24,
                    key: "finance",
                    filter: 'charge_financiere',
                    name: i18n.tc('charge_financiere')
                },
                {
                    id: 25,
                    key: "finance",
                    filter: 'resultat_net',
                    name: i18n.tc('resultat_net')
                },
                {
                    id: 26,
                    key: "finance",
                    filter: 'capitaux_propres',
                    name: i18n.tc('capitaux_propres')
                },
                {
                    id: 27,
                    key: "finance",
                    filter: 'effectifs_bilan',
                    name: i18n.tc('effectifs_bilan')
                },
                {
                    id: 28,
                    key: "finance",
                    filter: 'variation_chiffre_affaires',
                    name: i18n.tc('variation_chiffre_affaires')
                },
                {
                    id: 29,
                    key: "finance",
                    filter: 'marge_exploitation',
                    name: i18n.tc('marge_exploitation')
                },
                {
                    id: 30,
                    key: "finance",
                    filter: 'charge_financiere_sur_ca',
                    name: i18n.tc('charge_financiere_sur_ca')
                },
                {
                    id: 31,
                    key: "finance",
                    filter: 'surface_financiere',
                    name: i18n.tc('surface_financiere')
                },
                {
                    id: 32,
                    key: "finance",
                    filter: 'vetuste',
                    name: i18n.tc('vetuste')
                },
                {
                    id: 33,
                    key: "finance",
                    filter: 'marge_nette',
                    name: i18n.tc('marge_nette')
                },
                {
                    id: 34,
                    key: "finance",
                    filter: 'ebe',
                    name: i18n.tc('ebe')
                },
                {
                    id: 35,
                    key: "finance",
                    filter: 'rentabilite_capital',
                    name: i18n.tc('rentabilite_capital')
                },
                {
                    id: 36,
                    key: "finance",
                    filter: 'poids_ca_sur_cp',
                    name: i18n.tc('poids_ca_sur_cp')
                },
                {
                    id: 37,
                    key: "finance",
                    filter: 'capacite_autofinancement',
                    name: i18n.tc('capacite_autofinancement')
                },
                {
                    id: 38,
                    key: "finance",
                    filter: 'autonomie_financiere',
                    name: i18n.tc('autonomie_financiere')
                },
                {
                    id: 40,
                    key: "finance",
                    filter: 'disponibilites',
                    name: i18n.tc('disponibilites')
                }
            ]
        },
        {
            id: -4, key: "mandats", name: i18n.tc('enrichissement.data.datas.mandats'), children: [
                {
                    id: 41,
                    key: "mandats",
                    filter: 'libelle_fonction',
                    name: i18n.tc('libelle_fonction')
                },
                {
                    id: 42,
                    key: "mandats",
                    filter: 'date_prise_fonction',
                    name: i18n.tc('date_prise_fonction')
                },
                {
                    id: 43,
                    key: "mandats",
                    filter: 'type_fonction',
                    name: i18n.tc('type_fonction')
                },
                {
                    id: 44,
                    key: "mandats",
                    filter: 'statut_position',
                    name: i18n.tc('statut_position')
                },
                {
                    id: 45,
                    key: "mandats",
                    filter: 'nature_position',
                    name: i18n.tc('nature_position')
                },
                {
                    id: 47,
                    key: "mandats",
                    filter: 'contact_email',
                    name: i18n.tc('contact_email')
                },
                {
                    id: 48,
                    key: "mandats",
                    filter: 'contact_telephone',
                    name: i18n.tc('contact_telephone')
                }
            ]
        },
        {
            id: -5, name: i18n.tc('enrichissement.data.datas.directors'), children: [
                {
                    id: 49,
                    key: "directors",
                    filter: 'civilite',
                    name: i18n.tc('civilite')
                },
                {
                    id: 50,
                    key: "directors",
                    filter: 'nom_dirigeant',
                    name: i18n.tc('nom_dirigeant')
                },
                {
                    id: 51,
                    key: "directors",
                    filter: 'prenom_dirigeant',
                    name: i18n.tc('prenom_dirigeant')
                },
                {
                    id: 52,
                    key: "directors",
                    filter: 'nom_jeune_fille',
                    name: i18n.tc('nom_jeune_fille')
                },
                {
                    id: 53,
                    key: "directors",
                    filter: 'siren_dirigeant',
                    name: i18n.tc('siren_dirigeant')
                },
                {
                    id: 54,
                    key: "directors",
                    filter: 'lieu_naissance_ville',
                    name: i18n.tc('lieu_naissance_ville_dirigeant')
                },
                {
                    id: 55,
                    key: "directors",
                    filter: 'lieu_naissance_codepostal',
                    name: i18n.tc('lieu_naissance_codepostal')
                },
                {
                    id: 56,
                    key: "directors",
                    filter: 'lieu_naissance_pays',
                    name: i18n.tc('lieu_naissance_pays_dirigeant')
                },
                {
                    id: 57,
                    key: "directors",
                    filter: 'date_naissance',
                    name: i18n.tc('date_naissance_dirigeant')
                },
                {
                    id: 58,
                    key: "directors",
                    filter: 'nationalite',
                    name: i18n.tc('nationalite_dirigeant')
                },
                {
                    id: 59,
                    key: "directors",
                    filter: 'adresse_dirigeant',
                    name: i18n.tc('adresse_dirigeant')
                },
                {
                    id: 60,
                    key: "directors",
                    filter: 'adresse_dirigeant_complement',
                    name: i18n.tc('adresse_dirigeant_complement')
                },
                {
                    id: 61,
                    key: "directors",
                    filter: 'adresse_dirigeant_departement',
                    name: i18n.tc('adresse_dirigeant_departement')
                },
                {
                    id: 62,
                    key: "directors",
                    filter: 'adresse_dirigeant_ville',
                    name: i18n.tc('adresse_dirigeant_ville')
                },
                {
                    id: 63,
                    key: "directors",
                    filter: 'adresse_dirigeant_cedex',
                    name: i18n.tc('adresse_dirigeant_cedex')
                },
                {
                    id: 64,
                    key: "directors",
                    filter: 'adresse_dirigeant_pays',
                    name: i18n.tc('adresse_dirigeant_pays')
                }
            ]
        },
        {
            id: -6, key: "group", name: i18n.tc('enrichissement.data.datas.group'), children: [
                {
                    id: 65,
                    key: "group",
                    filter: 'siren_groupe',
                    name: i18n.tc('siren_groupe')
                },
                {
                    id: 65,
                    key: "group",
                    filter: 'raison_sociale_groupe',
                    name: i18n.tc('raison_sociale_groupe')
                },
                {
                    id: 66,
                    key: "group",
                    filter: 'siren_groupe_ultimate_france',
                    name: i18n.tc('siren_groupe_ultimate_france')
                },

                {
                    id: 67,
                    key: "group",
                    filter: 'raison_sociale_groupe_ultimate_france',
                    name: i18n.tc('raison_sociale_groupe_ultimate_france')
                },
                {
                    id: 70,
                    key: "group",
                    filter: 'nb_actionnaire',
                    name: i18n.tc('nb_actionnaire')
                },
                {
                    id: 71,
                    key: "group",
                    filter: 'nb_filiale_directe',
                    name: i18n.tc('nb_filiale_directe')
                },
                {
                    id: 72,
                    key: "group",
                    filter: 'nb_filiale_indirecte',
                    name: i18n.tc('nb_filiale_indirecte')
                },
                {
                    id: 73,
                    key: "group",
                    filter: 'chiffre_affaire_consolide',
                    name: i18n.tc('chiffre_affaire_consolide')
                },
                {
                    id: 74,
                    key: "group",
                    filter: 'efffectif_consolide',
                    name: i18n.tc('efffectif_consolide')
                },
                {
                    id: 75,
                    key: "group",
                    filter: 'resultat_net_consolide',
                    name: i18n.tc('resultat_net_consolide')
                },
            ]
        },
        {
            id: -7, name: i18n.tc('enrichissement.data.datas.filials'), children: [
                {
                    id: 76,
                    key: "filials",
                    filter: 'id_societe',
                    name: i18n.tc('siren_filiale')
                },
                {
                    id: 76,
                    key: "filials",
                    filter: 'detention',
                    name: i18n.tc('detention_filiale')
                }
            ]
        },
        {
            id: -8, name: i18n.tc('enrichissement.data.datas.shareholders'), children: [
                {
                    id: 76,
                    key: "shareholders",
                    filter: 'id_societe',
                    name: i18n.tc('siren_shareholders')
                },
                {
                    id: 80,
                    key: "shareholders",
                    filter: 'detention',
                    name: i18n.tc('detention_shareholders')
                }
            ]
        },
        {
            id: -9, name: i18n.tc('enrichissement.data.datas.capitalist'), children: [
                {
                    id: 84,
                    key: "capitalist",
                    filter: 'type_entite',
                    name: i18n.tc('type_entite')
                },
                {
                    id: 85,
                    key: "capitalist",
                    filter: 'civilite_entite',
                    name: i18n.tc('civilite_entite')
                },
                {
                    id: 86,
                    key: "capitalist",
                    filter: 'nom_entite',
                    name: i18n.tc('nom_entite')
                },
                {
                    id: 87,
                    key: "capitalist",
                    filter: 'prenom_entite',
                    name: i18n.tc('prenom_entite')
                },
                {
                    id: 88,
                    key: "capitalist",
                    filter: 'siren_entite',
                    name: i18n.tc('siren_entite')
                },
                {
                    id: 89,
                    key: "capitalist",
                    filter: 'adresse_entite',
                    name: i18n.tc('adresse_entite')
                },
                {
                    id: 90,
                    key: "capitalist",
                    filter: 'adresse_entite_complement',
                    name: i18n.tc('adresse_entite_complement')
                },
                {
                    id: 91,
                    key: "capitalist",
                    filter: 'adresse_entite_codepostal',
                    name: i18n.tc('adresse_entite_codepostal')
                },
                {
                    id: 92,
                    key: "capitalist",
                    filter: 'adresse_entite_ville',
                    name: i18n.tc('adresse_entite_ville')
                },
                {
                    id: 93,
                    key: "capitalist",
                    filter: 'adresse_entite_cedex',
                    name: i18n.tc('adresse_entite_cedex')
                },
                {
                    id: 94,
                    key: "capitalist",
                    filter: 'adresse_entite_pays',
                    name: i18n.tc('adresse_entite_pays')
                },
                {
                    id: 95,
                    key: "capitalist",
                    filter: 'lieu_naissance_ville',
                    name: i18n.tc('lieu_naissance_ville')
                },
                {
                    id: 96,
                    key: "capitalist",
                    filter: 'lieu_naissance_pays',
                    name: i18n.tc('lieu_naissance_pays')
                },
                {
                    id: 97,
                    key: "capitalist",
                    filter: 'date_naissance',
                    name: i18n.tc('date_naissance')
                },
                {
                    id: 98,
                    key: "capitalist",
                    filter: 'nationalite',
                    name: i18n.tc('nationalite')
                }
            ]
        }
    ];

    generateDataTypes(identity, company) {
        const identityArray = identity ? [identity] : [];
        const childrenIdentity = company ? identityArray.concat(this.identityCompany) : identityArray.concat(this.identityEstablishment);
        const dataWithoutIdentity = JSON.parse(JSON.stringify(this.dataWithoutIdentity));
        dataWithoutIdentity.unshift(
            {id: -1, name: i18n.tc('enrichissement.data.datas.identity'), children: childrenIdentity}
        );
        let i = 0;
        let j = -1;
        for (const data of dataWithoutIdentity) {
            for (const child of data.children) {
                child.id = i;
                i++;
            }
            data.id = j;
            j--;
        }
        return dataWithoutIdentity;
    }

    recapDisplay(fullData, selectedData) {
        if (fullData && fullData.length > 0) {
            const distinctKeys = selectedData.map(s => s.key).filter((value, index, self) => self.indexOf(value) === index);
            let res = [];
            for (const dataKey of distinctKeys) {
                const parent = fullData.filter(f => f.children.map(c => c.key).indexOf(dataKey) > -1)[0];
                if (selectedData.filter(s => s.key === dataKey).length === parent.children.length) {
                    res.push({
                        name: parent.name,
                        key: dataKey
                    });
                } else {
                    res = res.concat(selectedData.filter(s => s.key === dataKey));
                }
            }
            return res;
        } else {
            return selectedData;
        }
    }
}

export default new DataService();